import React from 'react';
import { Stack, Text } from '@mantine/core';
import { SurveyZoneStoreCount } from './SurveyZoneStoreCount';
import type { StoreWithNumber } from '../../pages/price-surveys/types';

interface SurveyHistoryDrawerHeaderProps {
    zoneName: string;
    stores: StoreWithNumber[];
    surveyPeriod: string;
    championStoreId?: string | null;
}

export function SurveyHistoryDrawerHeader({
    zoneName,
    stores,
    surveyPeriod,
    championStoreId,
}: SurveyHistoryDrawerHeaderProps) {
    return (
        <Stack gap={4} className="w-full">
            <Text size="xl" fw={700} className="text-primary m-0 leading-tight">
                Survey History - {zoneName}
            </Text>
            <SurveyZoneStoreCount
                stores={stores}
                championStoreId={championStoreId}
            />
            <Text size="sm" c="dimmed">
                Survey Period: {surveyPeriod}
            </Text>
        </Stack>
    );
}
